import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'outside_township/getEach?';
const allUrl = 'outside_township/get?';
const storeUrl = 'outside_township/store';
const updateUrl = 'outside_township/update?';
const deleteUrl = 'outside_township/delete?';

const state = {
  outsideTownships: [],
  outsideTownship: {},
};
const getters = {};
const mutations = {
  SET_OUTSIDE_TOWNSHIPS(state, payload) {
    state.outsideTownships = payload.data.data
  },
  SET_OUTSIDE_TOWNSHIP(state, payload) {
    state.outsideTownship = payload.data.data
  },
  ADD_OUTSIDE_TOWNSHIP(state, payload) {
    state.outsideTownships.push(payload.data.data)
  },
  REMOVE_OUTSIDE_TOWNSHIP(state, payload) {
    const townships = state.outsideTownships.filter((item) => item.id != payload.id)
    state.outsideTownships = [...townships]
  }
};

const actions = {
  async getAll({ commit }, payload) {
    const response = await Request.get_data(allUrl, payload)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit('SET_OUTSIDE_TOWNSHIPS', response)

  },
  async getEach({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_OUTSIDE_TOWNSHIP", response);
  },
  async create({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_OUTSIDE_TOWNSHIP", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async update(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deleteTownship({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_OUTSIDE_TOWNSHIP", response.data.data);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
